// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 23:25:58

export default {
  "id": "driftclicker",
  "slug": "driftclicker",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/a02de4821afa46c3b69dd95385c314db-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/a02de4821afa46c3b69dd95385c314db/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "DriftClicker",
      "description": "Race Clicker: DRIFT MAX is an action clicker that immerses you in the world of thrilling drift races, demanding lightning-fast reflexes and the ability to make decisions at high speed. Participate in dynamic drift where every turn is a high-speed challenge.\n- Open containers to obtain unique parts and enhance your car.\n- Participate in high-stakes races to earn keys for containers and unlock new possibilities.\n- Upgrade your car to dominate races and defeat all your rivals.",
      "instructions": "Clicker controls:\n1. Click on the car or use space to gain speed and earn money.\n2. Spend money on leveling up your car to drive faster.\n\nRace controls:\n1. Gain as much speed as possible by tapping or clicking the mouse or using space key at the beginning of the race.\n2. Control using the keys \"A\", \"D\" or swipes on the screen.\n3. Aim at the racers, catch up and knock them down.",
      "genres": [
        "Casual",
        "Racing & Driving"
      ],
      "tags": [
        "arcade",
        "car",
        "clicker",
        "drift",
        "street"
      ]
    },
    "zh-CN": {
      "title": "漂移点击器",
      "description": "赛车点击器：DRIFT MAX是一款动作点击器，让你沉浸在令人激动的漂移赛车世界中，要求你具备闪电般的反应速度和高速决策的能力。参与动态漂移，每一转弯都是一个高速挑战。\n- 打开容器以获得独特的部件并增强你的赛车。\n- 参与高风险的赛车以赚取容器钥匙并解锁新的可能性。\n- 升级你的赛车以在比赛中称霸并击败所有对手。",
      "instructions": "点击器控制：\n1. 点击汽车或使用空格键加速并获得金钱。\n2. 用金钱升级您的汽车以获得更快的驾驶速度。\n\n比赛控制：\n1. 在比赛开始时通过点击鼠标或按空格键尽可能获得速度。\n2. 使用“A”、“D”键或屏幕滑动进行控制。\n3. 对准赛车，追赶并击倒它们。",
      "genres": [
        "休闲",
        "赛车与驾驶"
      ],
      "tags": [
        "街机",
        "赛车",
        "点击器",
        "漂移",
        "街道"
      ]
    },
    "zh-TW": {
      "title": "漂流點擊器",
      "description": "賽車點擊器：DRIFT MAX 是一款動作點擊器遊戲，讓你沉浸於刺激的漂移賽車世界中，要求您具備光速反應和高速下作決策的能力。參與動態的漂移賽車，每個轉彎都充滿高速挑戰。\n- 開啟容器獲得獨特零件，升級您的愛車。\n- 參與高風險賽事，獲得開啟容器之鑰匙，開啟新的可能性。\n- 升級您的愛車，在賽事中稱霸，擊敗所有對手。",
      "instructions": "點擊器控制：\n1. 點擊車輛或使用空格鍵增加速度和獲得金錢。\n2. 使用金錢升級您的車輛以增加速度。\n\n賽車控制：\n1. 在賽車開始時，盡可能地點擊滑鼠或使用空格鍵來增加速度。\n2. 使用按鍵 \"A\"、\"D\" 或螢幕滑動來控制。\n3. 對準賽車手，追趕並將他們擊倒。",
      "genres": [
        "休闲",
        "賽車與駕駛"
      ],
      "tags": [
        "電玩",
        "車輛",
        "點擊器",
        "滑胎",
        "街道"
      ]
    },
    "zh-HK": {
      "title": "漂移點擊器",
      "description": "賽車點擊器：DRIFT MAX 是一款行動點擊遊戲，讓你深入體驗刺激的漂移賽車世界，要求你有電光石火般的反應和高速作決策的能力。參與動態漂移，每個轉彎都是高速挑戰。\n- 開啟容器以獲得獨特零件並提升你的車輛。\n- 參與高風險賽事以獲得容器鑰匙並開啟新機遇。\n- 升級你的車輛以主宰賽事並擊敗所有對手。",
      "instructions": "點擊器控制：\n1. 點擊車輛或使用空格鍵增加速度及賺取金錢。\n2. 使用金錢升級你的車輛以加速駕駛。\n\n賽車控制：\n1. 在賽車開始時，盡量點擊滑鼠或使用空格鍵以獲得最大速度。\n2. 使用鍵盤上的 \"A\"、\"D\" 鍵或螢幕上的滑動動作進行控制。\n3. 對準賽車選手，追上並將他們撞倒。",
      "genres": [
        "輕鬆",
        "賽車及駕駛"
      ],
      "tags": [
        "街機",
        "車輛",
        "點擊器",
        "漂移",
        "街道"
      ]
    },
    "ja": {
      "title": "ドリフトクリッカーサー",
      "description": "レースクリッカ：DRIFT MAXは、驚くほどの高速反射神経と高速での判断力を要求する、スリリングなドリフトレースの世界に没頭させるアクションクリッカです。動き回りのドリフトで、どんなターンも高速チャレンジです。\n- オープンしたコンテナからユニークなパーツを手に入れ、車を強化しましょう。\n- 高額のレースに参加して、コンテナの鍵を手に入れ、新しい可能性を解き放ちましょう。\n- レースを支配し、ライバルを打ち負かすために、車をアップグレードしましょう。",
      "instructions": "クリッカーコントロール：\n1. 車をクリックするかスペースキーを使用してスピードを上げてお金を稼ぎます。\n2. お金を使って車をレベルアップし、より速く走ることができます。\n\nレースコントロール：\n1. レースの開始時にマウスをタップしたりクリックしたり、スペースキーを使用してできるだけ多くのスピードを稼ぎます。\n2. キー“A”、“D”またはスクリーン上でのスワイプでコントロールします。\n3. レーサーに向けて狙い、追い越し、倒します。",
      "genres": [
        "カジュアル",
        "レース＆ドライビング"
      ],
      "tags": [
        "アーケード",
        "車",
        "クリッカーゲーム",
        "ドリフト",
        "ストリート"
      ]
    },
    "ko": {
      "title": "드리프트 클릭러",
      "description": "레이스 클릭어: 드라이브 맥스는 흥미진진한 드라이브 레이스 세계로 몰입시키는 액션 클릭러로, 빠른 반응 속도와 빠른 결정력이 필요합니다. 각ター닝이 고속 도전이 되는 동적 드라이브에 참여하세요.\n- 오픈 컨테이너를 통해 독특한 부품을 얻어 자동차를 강화하세요.\n- 높은 투자금을 걸은 레이스에 참여하여 컨테이너 열쇠를 얻고 새로운 가능성을 해금하세요.\n- 자동차를 업그레이드하여 레이스를 통제하고 모든 라이벌을 꺾어라.",
      "instructions": "클릭어뎁션 조작:\n1. 차량을 클릭하거나 공백키를 사용하여 속도를 얻고 돈을 벌세요.\n2. 돈을 사용하여 차량을 레벨업하고 더 빠르게 달릴 수 있도록 하세요.\n\n레이스 조작:\n1. 레이스 시작 시 마우스를 탭하거나 클릭하거나 공백키를 사용하여 가능한 많은 속도를 얻으세요.\n2. \"A\", \"D\" 키나 화면을 스와이프하여 조작하세요.\n3. 레이서를 향해 맞추고 추격하여 떨어뜨리세요.",
      "genres": [
        "캐주얼",
        "레이싱 & 드라이빙"
      ],
      "tags": [
        "아케이드",
        "자동차",
        "클리커",
        "드리프트",
        "거리"
      ]
    },
    "fr": {
      "title": "DriftClicker\nDrifterClicker",
      "description": "Race Clicker: DRIFT MAX est un clic-acteur d'action qui vous plonge dans le monde des courses de drift palpitantes, exigeant des réactions rapides et la capacité de prendre des décisions à grande vitesse. Participez à des drifts dynamiques où chaque virage est un défi à grande vitesse.\n- Ouvrez des conteneurs pour obtenir des pièces uniques et améliorer votre voiture.\n- Participez à des courses à enjeux élevés pour gagner des clés pour les conteneurs et débloquer de nouvelles possibilités.\n- Mettez à niveau votre voiture pour dominer les courses et vaincre tous vos rivaux.",
      "instructions": "Contrôles du clic :\n1. Cliquez sur la voiture ou utilisez l'espace pour gagner de la vitesse et de l'argent.\n2. Dépensez de l'argent pour améliorer votre voiture et la faire rouler plus vite.\n\nContrôles de la course :\n1. Gagnez le plus de vitesse possible en tapant ou en cliquant sur la souris ou en utilisant la touche espace au début de la course.\n2. Contrôlez en utilisant les touches \"A\", \"D\" ou des glissements sur l'écran.\n3. Ciblez les concurrents, rattrapez-les et les éliminez.",
      "genres": [
        "Facile",
        "Course et Conduite"
      ],
      "tags": [
        "arcade",
        "voiture",
        "clic",
        "drift",
        "rue"
      ]
    }
  }
};
